export const colors = {
  bg: '#f5efe2',
  bgSoft: 'rgba(156,122,63,0.05)',
  ink: '#171512',
  ink70: 'rgba(20,18,16,0.7)',
  ink65: 'rgba(20,18,16,0.65)',
  ink55: 'rgba(20,18,16,0.55)',
  ink50: 'rgba(20,18,16,0.5)',
  ink45: 'rgba(20,18,16,0.45)',
  ink40: 'rgba(20,18,16,0.4)',
  ink15: 'rgba(20,18,16,0.15)',
  ink10: 'rgba(20,18,16,0.1)',
  ink05: 'rgba(20,18,16,0.05)',
  ink04: 'rgba(20,18,16,0.04)',
  ink02: 'rgba(20,18,16,0.02)',
  gold: '#9c7a3f',
  goldDark: '#8a6b34',
  goldSoft: 'rgba(156,122,63,0.14)',
  goldFaint: 'rgba(156,122,63,0.4)',
  riverDeep: '#2f6690',
  riverMid: '#347f9f',
  riverBright: '#3aa6a0',
  riverLight: '#78c9be',
  riverFoam: '#d7eee7',
  bankSand: '#c8b98c',
  bankSage: '#8a9168',
  bankLeaf: '#596748',
  linkedToLake: '#348097',
};

export const fonts = {
  display: "'Space Grotesk', sans-serif",
  body: "'Inter', sans-serif",
  mono: "'JetBrains Mono', monospace",
};
